module.exports = __webpack_public_path__ + "static/media/C007.2578fd3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C007.jpg
// module id = 290
// module chunks = 0